import React, { useEffect } from 'react'
import {
  Container, Row, Col, Form, Card, CardBody,
  FormGroup, Input, Label, Button, FormFeedback,
  Modal, ModalBody, ModalHeader, ModalFooter, Alert
} from 'reactstrap'
import ReactSelect from 'react-select'
import Moment from 'moment'
import 'moment/locale/de'
import 'moment/locale/it'
import 'moment/locale/nl'

import _ from 'lodash'

import LoadingOverlay from 'components/Indicator/LoadingOverlay'

import Lang from 'Lang/General'

const RecipientsForm = ({
  data,
  onChangeRecipientsHOC,
  headerText,
  toggle,
  isOpen,
  status,
  onSubmit,
  recipientGroup,
  errorMessage,
  onLoadRecipients,
  selectedLanguage,
  activeRecipientLogs,
  mode
}) => {

  useEffect(() => {
    Moment.locale( selectedLanguage )
  }, [])

  const onChangeData = ( key, value ) => {
    let tmp = _.cloneDeep( data )
    let dataKey = ''
    tmp[key] = value

    if( mode === 'edit' ){
      dataKey = 'selectedRecipient'
    }else{
      dataKey = 'newRecipientData'
    }

    onChangeRecipientsHOC( dataKey, tmp )
  }
  let groupOptions = []
  recipientGroup && recipientGroup.map( item => {
    groupOptions.push({
      id: item.id,
      label: item.name,
      value: item.name
    })
  })
  const processData = () => {
    let tmpValue = []
    data.recipient_groups && data.recipient_groups.map( item => {
      tmpValue.push(
        {
          id: item.id,
          label: item.name,
          value: item.name
        }
      )
    })
    return tmpValue
  }
  return(
    <Modal
      toggle={ toggle }
      isOpen={ isOpen }
      size="xl">
      <ModalHeader toggle={ toggle }>{ headerText }</ModalHeader>
      <ModalBody>
        <Container>
          <Row>
            <Col md={ 12 }>
              <Alert color="primary">
                { Lang[ 'IMPORTANT_NOTE_RECIPIENT_ADD' ][ selectedLanguage ] }
              </Alert>
            </Col>
            <Col md={ 8 }>
              <Card>
                <CardBody>
                  <Form>
                    <FormGroup>
                      <Label>{ Lang[ 'EMAIL' ][ selectedLanguage ] }</Label>
                      <Input
                        type={ 'email' }
                        value={ data.email }
                        onChange={ e => {
                          errorMessage["email"] = ""
                          onChangeData( 'email', e.target.value )
                        }}
                        invalid={ errorMessage && errorMessage.email ? true : false } />
                      <FormFeedback>{ errorMessage && errorMessage.email ? errorMessage.email : '' }</FormFeedback>
                    </FormGroup>
                    <FormGroup>
                      <Label for="salutation">{ Lang[ 'SALUTATION' ][ selectedLanguage ] }</Label>
                      <Input
                        type="text"
                        name="salutation"
                        id="salutation"
                        value={ data.salutation }
                        onChange={ e => onChangeData( 'salutation', e.target.value ) }/>
                    </FormGroup>
                    <FormGroup>
                      <Label>{ Lang[ 'FIRST_NAME' ][ selectedLanguage ] }</Label>
                      <Input
                        type={ 'text' }
                        value={ data.first_name }
                        onChange={ e => onChangeData( 'first_name', e.target.value ) }
                        invalid={ errorMessage && errorMessage.first_name ? true : false } />
                      <FormFeedback>{ errorMessage && errorMessage.first_name ? errorMessage.first_name : '' }</FormFeedback>
                    </FormGroup>
                    <FormGroup>
                      <Label>{ Lang[ 'LAST_NAME' ][ selectedLanguage ] }</Label>
                      <Input
                        type={ 'text' }
                        value={ data.last_name }
                        onChange={ e => onChangeData( 'last_name', e.target.value ) }
                        invalid={ errorMessage && errorMessage.last_name ? true : false } />
                      <FormFeedback>{ errorMessage && errorMessage.last_name ? errorMessage.last_name : '' }</FormFeedback>
                    </FormGroup>
                    {/* <FormGroup>
                      <Label>{ Lang[ 'MOBILE_NUMBER' ][ selectedLanguage ] }</Label>
                      <Input
                        type={ 'text' }
                        value={ data.mobile_number }
                        onChange={ e => onChangeData( 'mobile_number', e.target.value ) }
                        invalid={ errorMessage && errorMessage.mobile_number ? true : false } />
                      <FormFeedback>{ errorMessage && errorMessage.mobile_number ? errorMessage.mobile_number : '' }</FormFeedback>
                    </FormGroup> */}
                    {
                      mode === 'edit' && (
                        <FormGroup>
                          <Label for="status">{ Lang[ 'STATUS' ][ selectedLanguage ] }</Label>
                          <Input
                            type="select"
                            name="status"
                            id="status"
                            invalid={ false }
                            value={ data.status }
                            onChange={ e => onChangeData( 'status', e.target.value ) }>
                            {
                              status && Object.keys( status ).map( key => {
                                if( key !== 'archived' ) {
                                  return (
                                    <option key={ key } value={ status[key] }>{ Lang[ status[key]][ selectedLanguage ] }</option>
                                  )
                                }
                              })
                            }
                            <option value="DOI">{'DOI'}</option>
                          </Input>
                        </FormGroup>
                      )
                    }
                    <FormGroup>
                      <Label>{ Lang[ 'GROUP' ][ selectedLanguage ] }</Label>
                      <ReactSelect
                        isMulti
                        name="select"
                        options={ groupOptions }
                        placeholder={ Lang[ 'SELECT_GROUP' ][ selectedLanguage ] }
                        className="search-select"
                        classNamePrefix="select"
                        onChange={ selectedValue => {
                          let tmp = []
                          let ids = 0
                          selectedValue &&  selectedValue.map( item => {
                            if( item.id === 0 ){
                              tmp = []
                              groupOptions.map( group => {
                                if( group.id !== 0 ){
                                  tmp.push(
                                    {
                                      id: group.id,
                                      name: group.label,
                                    }
                                  )
                                }
                              })
                            } else {
                              tmp.push(
                                {
                                  id: item.id,
                                  name: item.label,
                                }
                              )
                            }
                          })
                          onChangeData( 'recipient_groups', tmp )
                        }}
                        value={ processData() }/>
                    </FormGroup>
                  </Form>
                </CardBody>
              </Card>
            </Col>
            <Col md={ 4} style={{ overflowY: 'scroll', height: '650px' }}>
            {
              activeRecipientLogs && activeRecipientLogs.map( item => {
                return (
                  <Card key={ item.id } className="mb-2">
                    <CardBody>
                      <p style={{ fontWeight: '600' }}>{ item[ selectedLanguage ] }</p>
                      <span>{ Moment( item.created_at ).format( 'DD MMM YYYY HH:mm:ss' ) }</span>
                    </CardBody>
                  </Card>
                )
              })
            }
            </Col>
          </Row>
        </Container>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={ onSubmit }>{ Lang[ 'SUBMIT' ][ selectedLanguage ] }</Button>
        <Button color="primary" onClick={ toggle }>{ Lang[ 'CANCEL' ][ selectedLanguage ] }</Button>
      </ModalFooter>
      { onLoadRecipients && <LoadingOverlay /> }
    </Modal>
  )
}

export default RecipientsForm
